import { AUTH_ERROR_MESSAGES } from './authErrorMessages';
import { travelEnUS, travelZhCN, travelZhTW } from './travelMessages';

/** 會員端 UI 文案（key 與語系 lang_code 對應） */
const zh_TW = {
  authErrors: AUTH_ERROR_MESSAGES.zh_TW,
  emailVerification: { accepted: '請求已受理；符合條件時將嘗試寄送，尚不代表已寄出或送達。未收到可稍後重試。', receiptInvalid: '無法確認請求是否受理，請稍後再試。' },
  common: {
    hint: '提示',
    cancel: '取消',
    confirm: '確認',
    close: '關閉',
    loading: '載入中…',
    noData: '無資料',
    dash: '—',
    back: '返回',
    search: '搜索',
  },
  trade: {
    positions: '持倉明細',
    buyUp: '買漲',
    buyDown: '買跌',
    pendingDraw: '待開獎',
    unsettled: '未結算',
    settlementCountdown: '結算倒數',
    settlementTime: '交割時間',
    orderAmount: '下單金額',
    fillPrice: '成交價',
    currentPrice: '現價',
    profitLoss: '盈虧金額',
    fee: '手續費',
    cancelOrder: '撤單',
    cancelConfirm: '確認將當前委託訂單撤銷？',
    cancelSuccess: '訂單撤銷成功',
    cancelFailed: '撤單失敗',
    placeOrderFailed: '下單失敗',
    loadProductsFailed: '載入商品失敗',
    chartAria: 'K 線',
    stateBooked: '已下單',
    stateSettled: '已結算',
    stateCancelled: '已取消',
  },
  orders: {
    title: '訂單',
    tabTimed: '限時',
    tabFutures: '交割',
    tabPerpetual: '永續',
    positions: '持倉明細',
    history: '歷史明細',
    pending: '當前委託',
    open: '持倉中',
    entrustHistory: '歷史委託',
    positionHistory: '歷史持倉',
    loadFailed: '載入訂單失敗',
    closeFailed: '平倉失敗',
  },
  follow: {
    oneClick: '一鍵跟單',
    title: '一鍵跟單',
    deliveryTitle: '交割跟單',
    signalsLabel: '動態口令',
    signalsPlaceholder: '請輸入動態口令',
    signalsInvalid: '動態口令不正確',
    submit: '送出',
    name: '名稱',
    period: '週期',
    followAmount: '跟單金額',
    minFollowAmount: '最低跟單金額',
    maxFollowAmount: '最高跟單金額',
    confirmTitle: '跟單',
    confirmMessage: '確認要跟單 {amount}(USDT)嗎？',
    success: '跟單成功！',
    loadFailed: '載入跟單失敗',
    placeFailed: '跟單失敗',
    noMore: '沒有更多了',
    amountOutOfRange: '金額須在 {min} ~ {max} 之間',
  },
  settings: {
    title: '通用設定',
    language: '語言',
    languageTitle: '語言',
    fiatCurrency: '法幣類型',
    version: '版本',
    logout: '登出',
    login: '登錄',
    loadLanguagesFailed: '語系列表載入失敗',
  },
  security: {
    title: '安全中心',
    email: '信箱',
    phone: '手機',
    withdrawPassword: '提現密碼',
    loginPassword: '登入密碼',
    notBound: '未綁定',
    goSet: '去設置',
    modify: '修改',
    set: '設定',
    withdrawPasswordSetTitle: '提現密碼設定',
    withdrawPasswordModifyTitle: '提現密碼設定',
    loginPasswordModifyTitle: '登入密碼設定',
    tabPhone: '手機',
    tabEmail: '郵箱',
    phoneNumber: '手機號碼',
    verifyCode: '驗證碼',
    verifyCodePlaceholder: '請輸入驗證碼',
    sendCode: '發送驗證碼',
    codeSent: '驗證碼已發送',
    oldPassword: '舊密碼',
    oldPasswordPlaceholder: '請輸入舊密碼',
    newPassword: '新密碼',
    newPasswordPlaceholder: '請輸入新密碼',
    confirmPassword: '再次輸入密碼',
    confirmPasswordPlaceholder: '請再次輸入密碼',
    passwordFormat: '密碼須為 6～12 字且不含空白',
    passwordMismatch: '兩次輸入的密碼不一致',
    saveFailed: '密碼設定失敗',
    codeSendFailed: '驗證碼發送失敗',
    emailMissing: '尚未綁定信箱',
    phoneMissing: '尚未綁定手機',
  },
  funds: {
    title: '資金',
    detailsTitle: '資金明細',
    details: '明細',
    deposit: '入款',
    withdraw: '取款',
    tabAll: '全部',
    tabDeposit: '入款紀錄',
    tabWithdraw: '取款紀錄',
    tabTimed: '限時',
    tabFutures: '交割',
    tabPerpetual: '永續',
    positionsTitle: '持倉',
    todayProfit: '今日收益 ({coin})',
    positionMargin: '倉位保證金',
    futuresHolding: '持倉中',
    marginBalance: '保證金餘額 ({coin})',
    unrealizedPnl: '未實現盈虧 ({coin})',
    historyPositions: '歷史持倉',
    openPositions: '持有倉位',
    positionAmountLabel: '金額 {amount}',
    positionLoginHint: '登入後可查看持倉資料',
    positionLoadFailed: '載入持倉資料失敗',
    directionUp: '買漲',
    directionDown: '買跌',
    directionLong: '做多',
    directionShort: '做空',
    perpetualStatusOpen: '持倉中',
    perpetualStatusPending: '委託中',
    perpetualStatusClosed: '已平倉',
    perpetualStatusLiquidated: '已強平',
    totalAssets: '帳戶總資產 ({coin})',
    available: '可用',
    locked: '鎖定',
    staked: '鎖倉',
    withdrawalStats: '提款統計',
    showBalance: '顯示餘額',
    hideBalance: '隱藏餘額',
    feeLabel: '手續費 : {amount}',
    balanceLabel: '餘額 : {amount}',
    depositAmountLabel: '充幣{currency} : {amount}',
    withdrawAmountLabel: '金額 {currency} : {amount}',
    receivedAmountLabel: '預計到帳數量 : {amount}',
    loadFailed: '載入資金資料失敗',
    loadMore: '載入更多',
    noMore: '沒有更多了',
    paymentStatus: {
      NONE: '無狀態',
      PENDING: '待處理',
      PROCESSING: '處理中',
      WAITING_CALLBACK: '待回調',
      FAIL: '失敗',
      REJECT: '拒絕',
      SUCCESS: '已完成',
      TIMEOUT: '超時',
      EXCEPTION: '異常',
    },
    depositType: {
      RECHARGE_SYSTEM: '註冊禮金',
      RECHARGE_ONLINE: '在線充值',
      RECHARGE_OFFLINE: '線下充值',
    },
    transactionType: {
      RECHARGE_SYSTEM: '系統上分',
      RECHARGE_ONLINE: '在線充值',
      RECHARGE_OFFLINE: '離線充值',
      WITHDRAWAL_SYSTEM: '系統下分',
      WITHDRAWAL_ONLINE: '線上提款',
      WITHDRAWAL_OFFLINE: '線下提現',
      WITHDRAWAL_MEMBER: '用戶提現',
      WITHDRAW_RETURN: '取消用戶提現退款',
      ORDER_BET: '下單扣款',
      ORDER_PAYOUT: '派彩入帳',
      ORDER_REFUND: '撤單退款',
      ORDER_FEE: '下單手續費',
      FUTURE_ORDER: '交割合約委託',
      FUTURE_FOLLOW: '交割跟單委託',
      FUTURE_ORDER_CANCEL: '交割合約撤單',
      FUTURE_EXECUTION: '交割合約結算',
      TIME_LIMITED_ORDER: '限時委託',
      TIME_LIMITED_EXECUTION: '限時成交',
      TIME_LIMITED_REFUND: '限時失敗退款',
      PERPETUAL_ORDER: '永續合約委託',
      PERPETUAL_ORDER_CANCEL: '永續合約撤單',
      PERPETUAL_EXECUTION: '永續合約平倉結算',
      PERPETUAL_FEE: '永續合約手續費',
      PERPETUAL_PROFIT: '永續合約盈利',
      PERPETUAL_LOSS: '永續合約虧損',
      PERPETUAL_LIQUIDATION: '永續合約強平',
    },
  },
  deposit: {
    title: '入款',
    onlineTitle: '商戶充值',
    offlineTitle: '在線充值',
    offlineFormTitle: '在線充值',
    loadMerchantsFailed: '載入商戶失敗',
    loadChannelsFailed: '載入充值通道失敗',
    loadAddressesFailed: '載入充值地址失敗',
    submitFailed: '提交失敗',
    onlineSubmitSuccess: '線上充值訂單已建立',
    offlineSubmitSuccess: '入款提交成功',
    gotIt: '知道了',
    uploadFailed: '憑證上傳失敗',
    currency: '幣種',
    chainName: '鏈名稱: ({chain})',
    quickAmounts: '充值快捷金額',
    amountTitle: '入款金額',
    rechargeRange: '可充值金額：{range}',
    estimatedArrival: '預估到帳金額',
    all: '全部',
    reset: '重置',
    rateHint: '實際匯率以系統審核為主(此為參考價)',
    rebateRate: '獎勵金返現比例：{rate}%',
    rebateAmount: '獎勵金 ({coin})：{amount}',
    submit: '提交',
    selectCurrency: '選擇幣種',
    noChannels: '此商戶暫無可充值幣種',
    copy: '複製',
    copied: '已複製',
    uploadReceipt: '上傳轉賬憑證',
    receiptAlt: '轉賬憑證',
    txIdPlaceholder: '請輸入TxId',
  },
  kyc: {
    hubTitle: '身份認證',
    formTitle: '填寫認證信息',
    basicTitle: '基本認證',
    identityTitle: '身份認證',
    basicDesc: '完成基本的電子郵件或手機身份驗證，因此將通過電子郵件或手機自動通知資金交易，並立即跟蹤市場動態。',
    identityDesc: '根據當地法律法規，您需要完成身份認證才能使用我們的完整服務。',
    goVerify: '去認證',
    reVerify: '重新認證',
    viewContent: '查看認證內容',
    infoTitle: 'KYC認證資訊',
    imageVerified: '已認證',
    infoEmpty: '暫無認證資料',
    info: {
      country: '國家/地區',
      uploadIdPhoto: '上傳證件照',
    },
    submit: '提交',
    promptMessage: '請您先設定KYC認證',
    verifyLater: '稍後認證',
    setupNow: '現在設置',
    submittedBanner: '申請已提交',
    loadFailed: '載入認證資料失敗',
    submitFailed: '認證提交失敗',
    uploadFailed: '證件照片上傳失敗',
    selectCountry: '請選擇國家/地區',
    selectGender: '請選擇性別',
    selectCertType: '請選擇證件類型',
    uploadFront: '上傳證件照正面',
    uploadBack: '上傳證件照背面',
    status: {
      verified: '已認證',
      auditing: '審核中',
      failed: '認證失敗',
      notCertified: '未認證',
    },
    certType: {
      idCard: '身份證',
      passport: '護照',
      driverLicense: '駕照',
    },
    gender: {
      male: '男',
      female: '女',
    },
    fields: {
      country: '國家/地區',
      image: '證件照片上傳',
      birthday: '生日',
      gender: '性別',
      realName: '名字',
      lastName: '姓氏',
      certType: '證件類型',
      identityNumber: '證件號碼',
    },
    placeholder: {
      realName: '請輸入名字',
      lastName: '請輸入姓氏',
      identityNumber: '請輸入證件號碼',
    },
    validation: {
      required: '此欄位為必填',
      imageBoth: '請上傳證件照正反面',
    },
  },
  withdraw: {
    title: '取款',
    currency: '幣種',
    walletAddress: '錢包地址',
    addAddress: '錢包地址新增',
    addressNotSelected: '尚未選擇',
    amountTitle: '取款金額',
    maxAmount: '最大：{amount}',
    submit: '提交',
    loadFailed: '載入取款資料失敗',
    submitFailed: '提款失敗',
    selectAddress: '請選擇提款地址',
    invalidAmount: '請輸入有效提款金額',
    passwordTitle: '提現密碼',
    passwordLabel: '輸入提現密碼',
    passwordRequired: '請輸入交易密碼',
    noSetJyPassword: '請先設定提現密碼',
    channel: '通道',
    walletAddressPlaceholder: '請輸入錢包地址',
    bindSubmit: '綁定',
    bindFailed: '綁定失敗',
    bindAddressRequired: '請輸入錢包地址',
    addressPromptMessage: '請先新增出款方式',
    addressPromptLater: '稍後新增',
    addressPromptSetup: '現在設置',
    addressListTitle: '出金地址',
    boundSection: '已綁定',
    addSection: '新增出款方式',
    bindSuccessBanner: '綁定錢包地址成功',
    manageAddress: '管理地址',
    unbindAction: '解綁出款方式',
    noChannelToAdd: '暫無可新增的出款通道',
    manageAddresses: '管理出款地址',
    bindPageTitle: '綁定錢包地址',
    bindSecurityNotice: '請確認錢包地址與鏈路正確，錯誤地址可能導致資產無法找回。',
    unbindPageTitle: '解綁出款方式',
    unbindTabEmail: '信箱驗證',
    unbindTabPhone: '手機驗證',
    unbindVerifyCode: '驗證碼',
    unbindVerifyCodePlaceholder: '請輸入驗證碼',
    unbindSendCode: '發送驗證碼',
    unbindCodeSent: '驗證碼已發送',
    unbindSubmit: '解綁',
    unbindFailed: '解綁失敗',
    unbindCodeRequired: '請輸入驗證碼',
    unbindCodeSendFailed: '驗證碼發送失敗',
    unbindEmailMissing: '尚未綁定信箱',
    unbindPhoneMissing: '尚未綁定手機號',
    setupAddressAction: '設置出款方式',
    methodsTitle: '取款方式',
    noMethodCategory: '暫無可選取款方式',
    bindBankPageTitle: '綁定銀行卡',
    bindEwalletPageTitle: '綁定支付帳號',
    bindBankSecurityNotice: '請確認銀行卡資訊正確，錯誤資訊可能導致出款失敗。',
    bindEwalletSecurityNotice: '請確認支付帳號正確，錯誤帳號可能導致出款失敗。',
    bindAccountName: '戶名',
    bindAccountNamePlaceholder: '請輸入戶名',
    bindAccountNameRequired: '請輸入戶名',
    bindBankName: '開戶行',
    bindBankNamePlaceholder: '請輸入開戶行名稱',
    bindCardNumber: '銀行卡號',
    bindCardNumberPlaceholder: '請輸入銀行卡號',
    bindCardNumberRequired: '請輸入銀行卡號',
    bindEwalletAccount: '支付帳號',
    bindEwalletAccountPlaceholder: '請輸入支付帳號',
    selectCurrency: '選擇幣種',
    bankCard: '銀行卡',
    availableAmount: '可取款金額 {amount}',
    amountLabel: '{currency} 取款金額',
    estimatedArrival: '預估到帳金額',
    exchangeRateNote: '實際匯率以系統審核為主（此為參考價）',
    handlingFee: '手續費',
    feeNote: '您的本次取款，手續費將在您本次的取款金額中扣除，實際金額以實際到帳金額為準。',
    noWithdrawableChannel: '暫無可用的提款通道，請確認已綁定地址且後台已開啟提現通道',
    copyAddress: '複製地址',
    copied: '已複製',
    copyFailed: '複製失敗',
    exceedMaxAmount: '超過可取款上限 {amount}',
  },
  news: {
    title: '國際新聞',
    more: '更多 ›',
    empty: '暫無新聞',
    loadFailed: '載入失敗',
    prevPage: '上一頁',
    nextPage: '下一頁',
  },
  messages: {
    title: '訊息公告',
    readAll: '全部已讀',
    tabInbox: '站內信',
    tabAnnouncement: '公告',
    empty: '無資料',
    loadFailed: '載入失敗',
    prevPage: '上一頁',
    nextPage: '下一頁',
  },
  helpCenter: {
    title: '幫助中心',
    searchPlaceholder: '請輸入您的問題',
    faqTitle: '常見問題',
    empty: '暫無幫助內容',
    loadFailed: '載入失敗',
  },
  aboutUs: {
    title: '關於我們',
  },
  beginnerGuide: {
    title: '新手指南',
  },
  support: {
    title: '客服中心',
    defaultName: '客服',
    contactNow: '立即溝通',
    copied: '已複製到剪貼簿',
    empty: '暫無可用客服',
    offlineHint: '目前非客服在線時段',
    loadFailed: '載入失敗',
  },
  auth: {
    navRegister: '註冊',
    navLogin: '登入',
    googleSignIn: '使用 Google 登入',
    googleSignUp: '使用 Google 註冊',
    googleCredentialMissing: '未取得 Google 憑證',
    googleLoginFailed: 'Google 登入失敗，請稍後再試',
  },
  login: {
    title: '歡迎回來',
    tabEmail: 'Email 登入',
    tabMobile: '手機登入',
    usernamePlaceholder: '請輸入帳號或 Email',
    mobilePlaceholder: '請輸入手機號碼',
    passwordPlaceholder: '請輸入您的密碼',
    rememberMe: '記住我',
    forgotPassword: '忘記密碼？',
    submit: '登入',
    submitting: '登入中…',
    touristSubmit: '遊客試玩（免註冊）',
    touristSubmitting: '建立試玩帳號中…',
    divider: '或使用以下方式登入',
    loginFailed: '登入失敗，請稍後再試',
    touristFailed: '試玩帳號建立失敗，請稍後再試',
  },
  register: {
    title: '建立帳號',
    subtitle: '註冊成功後將自動登入',
    tabEmail: 'Email 註冊',
    tabMobile: '手機註冊',
    username: '帳號',
    password: '密碼（6～12 字，不含空白）',
    nickname: '暱稱（選填）',
    email: 'Email',
    mobile: '手機號碼',
    inviterCode: '邀請碼',
    verifyCode: '驗證碼',
    sendCode: '發送驗證碼',
    sendingCode: '發送中…',
    submit: '註冊',
    submitting: '註冊中…',
    divider: '或使用以下方式註冊',
    agreePrefix: '打勾即代表同意',
    userAgreement: '用戶協議',
    privacyPolicy: '隱私條款',
    agreeConnector: '&',
    agreeRequired: '請先勾選用戶協議與隱私條款',
    emailRequired: '請先填寫 Email',
    mobileRequired: '請先填寫手機號碼',
    codeSent: '驗證碼已發送',
    sendCodeFailed: '驗證碼發送失敗',
    registerFailed: '註冊失敗，請稍後再試',
  },
  invite: {
    title: '好友邀請',
    hint: '分享您的邀請碼或邀請連結，好友註冊時將自動帶入您的推廣碼。',
    codeLabel: '我的邀請碼',
    linkLabel: '邀請連結',
    copyCode: '複製邀請碼',
    copyLink: '複製連結',
    copied: '已複製到剪貼簿',
    copyFailed: '複製失敗',
    loadFailed: '載入失敗',
  },
  backfillInviter: {
    title: '輸入邀請碼',
    hint: '您註冊時未填寫邀請碼，可在此補填。成功後僅影響後續佣金歸屬，不影響下單、提現等權益。',
    codeLabel: '邀請碼',
    codePlaceholder: '請輸入邀請人的邀請碼',
    codeRequired: '請輸入邀請碼',
    submit: '確認提交',
    submitFailed: '提交失敗，請稍後再試',
    loadFailed: '載入失敗',
    notAvailable: '目前無法補填邀請碼（可能已綁定上級、已過期限，或您為代理帳號）。',
    deadline: '補填截止時間：{deadline}',
    success: '已成功綁定邀請人：{inviter}',
  },
  agreement: {
    title: '用戶協議',
    loadFailed: '載入失敗',
    empty: '暫無內容',
  },
  privacyPolicy: {
    title: '隱私條款',
    loadFailed: '載入失敗',
    empty: '暫無內容',
  },
  chat: {
    mutedUntil: '你已被禁言，距離解禁還有：{remaining}；仍可查看歷史對話',
    mutedPermanent: '你已被永久禁言，無法發送訊息；仍可查看歷史對話',
    muteRemainingDays: '{0} 天',
    muteRemainingHours: '{0} 小時',
    muteRemainingMinutes: '{0} 分鐘',
    mutePermanent: '永久',
  },
  travel: travelZhTW,
};

const en_US = {
  authErrors: AUTH_ERROR_MESSAGES.en_US,
  emailVerification: { accepted: 'Request accepted. Delivery will be attempted if eligible; sending and receipt are not guaranteed. Retry later if needed.', receiptInvalid: 'The request could not be confirmed. Please try again later.' },
  common: {
    hint: 'Notice',
    cancel: 'Cancel',
    confirm: 'Confirm',
    close: 'Close',
    loading: 'Loading…',
    noData: 'No data',
    dash: '—',
    back: 'Back',
    search: 'Search',
  },
  trade: {
    positions: 'Positions',
    buyUp: 'Buy Up',
    buyDown: 'Buy Down',
    pendingDraw: 'Pending',
    unsettled: 'Unsettled',
    settlementCountdown: 'Settlement countdown',
    settlementTime: 'Settlement',
    orderAmount: 'Order Amount',
    fillPrice: 'Fill Price',
    currentPrice: 'Current Price',
    profitLoss: 'P/L',
    fee: 'Fee',
    cancelOrder: 'Cancel order',
    cancelConfirm: 'Cancel this open order?',
    cancelSuccess: 'Order canceled',
    cancelFailed: 'Cancel failed',
    placeOrderFailed: 'Order failed',
    loadProductsFailed: 'Failed to load products',
    chartAria: 'Chart',
    stateBooked: 'Booked',
    stateSettled: 'Settled',
    stateCancelled: 'Canceled',
  },
  orders: {
    title: 'Orders',
    tabTimed: 'Timed',
    tabFutures: 'Delivery',
    tabPerpetual: 'Perpetual',
    positions: 'Positions',
    history: 'History',
    pending: 'Open Orders',
    open: 'In Position',
    entrustHistory: 'Order History',
    positionHistory: 'Position History',
    loadFailed: 'Failed to load orders',
    closeFailed: 'Close failed',
  },
  follow: {
    oneClick: 'One-Click Copy',
    title: 'One-Click Copy',
    deliveryTitle: 'Delivery Copy',
    signalsLabel: 'Passcode',
    signalsPlaceholder: 'Enter passcode',
    signalsInvalid: 'Invalid passcode',
    submit: 'Submit',
    name: 'Name',
    period: 'Period',
    followAmount: 'Copy Amount',
    minFollowAmount: 'Min Copy Amount',
    maxFollowAmount: 'Max Copy Amount',
    confirmTitle: 'Copy Trade',
    confirmMessage: 'Confirm copy trade {amount}(USDT)?',
    success: 'Copy trade successful!',
    loadFailed: 'Failed to load copy trades',
    placeFailed: 'Copy trade failed',
    noMore: 'No more',
    amountOutOfRange: 'Amount must be between {min} and {max}',
  },
  settings: {
    title: 'General Settings',
    language: 'Language',
    languageTitle: 'Language',
    fiatCurrency: 'Fiat Currency',
    version: 'Version',
    logout: 'Log out',
    login: 'Log in',
    loadLanguagesFailed: 'Failed to load languages',
  },
  security: {
    title: 'Security Center',
    email: 'Email',
    phone: 'Phone',
    withdrawPassword: 'Withdrawal Password',
    loginPassword: 'Login Password',
    notBound: 'Not bound',
    goSet: 'Set up',
    modify: 'Modify',
    set: 'Set',
    withdrawPasswordSetTitle: 'Withdrawal Password',
    withdrawPasswordModifyTitle: 'Withdrawal Password',
    loginPasswordModifyTitle: 'Login Password',
    tabPhone: 'Phone',
    tabEmail: 'Email',
    phoneNumber: 'Phone Number',
    verifyCode: 'Verification Code',
    verifyCodePlaceholder: 'Enter verification code',
    sendCode: 'Send Code',
    codeSent: 'Code sent',
    oldPassword: 'Current Password',
    oldPasswordPlaceholder: 'Enter current password',
    newPassword: 'New Password',
    newPasswordPlaceholder: 'Enter new password',
    confirmPassword: 'Confirm Password',
    confirmPasswordPlaceholder: 'Re-enter password',
    passwordFormat: 'Password must be 6–12 characters with no spaces',
    passwordMismatch: 'Passwords do not match',
    saveFailed: 'Failed to update password',
    codeSendFailed: 'Failed to send verification code',
    emailMissing: 'Email not bound',
    phoneMissing: 'Phone not bound',
  },
  funds: {
    title: 'Funds',
    detailsTitle: 'Fund Details',
    details: 'Details',
    deposit: 'Deposit',
    withdraw: 'Withdraw',
    tabAll: 'All',
    tabDeposit: 'Deposits',
    tabWithdraw: 'Withdrawals',
    tabTimed: 'Timed',
    tabFutures: 'Delivery',
    tabPerpetual: 'Perpetual',
    positionsTitle: 'Positions',
    todayProfit: 'Today P/L ({coin})',
    positionMargin: 'Position Margin',
    futuresHolding: 'In Position',
    marginBalance: 'Margin Balance ({coin})',
    unrealizedPnl: 'Unrealized P/L ({coin})',
    historyPositions: 'Position History',
    openPositions: 'Open Positions',
    positionAmountLabel: 'Amount {amount}',
    positionLoginHint: 'Log in to view positions',
    positionLoadFailed: 'Failed to load positions',
    directionUp: 'Buy Up',
    directionDown: 'Buy Down',
    directionLong: 'Long',
    directionShort: 'Short',
    perpetualStatusOpen: 'Open',
    perpetualStatusPending: 'Pending',
    perpetualStatusClosed: 'Closed',
    perpetualStatusLiquidated: 'Liquidated',
    totalAssets: 'Total Assets ({coin})',
    available: 'Available',
    locked: 'Locked',
    staked: 'Staked',
    withdrawalStats: 'Withdrawal Stats',
    showBalance: 'Show balance',
    hideBalance: 'Hide balance',
    feeLabel: 'Fee : {amount}',
    balanceLabel: 'Balance : {amount}',
    depositAmountLabel: 'Deposit {currency} : {amount}',
    withdrawAmountLabel: 'Amount {currency} : {amount}',
    receivedAmountLabel: 'Est. received : {amount}',
    loadFailed: 'Failed to load funds',
    loadMore: 'Load more',
    noMore: 'No more',
    paymentStatus: {
      NONE: 'None',
      PENDING: 'Pending',
      PROCESSING: 'Processing',
      WAITING_CALLBACK: 'Waiting callback',
      FAIL: 'Failed',
      REJECT: 'Rejected',
      SUCCESS: 'Completed',
      TIMEOUT: 'Timeout',
      EXCEPTION: 'Exception',
    },
    depositType: {
      RECHARGE_SYSTEM: 'Registration Bonus',
      RECHARGE_ONLINE: 'Online Deposit',
      RECHARGE_OFFLINE: 'Offline Deposit',
    },
    transactionType: {
      RECHARGE_SYSTEM: 'System Credit',
      RECHARGE_ONLINE: 'Online Deposit',
      RECHARGE_OFFLINE: 'Offline Deposit',
      WITHDRAWAL_SYSTEM: 'System Debit',
      WITHDRAWAL_ONLINE: 'Online Withdrawal',
      WITHDRAWAL_OFFLINE: 'Offline Withdrawal',
      WITHDRAWAL_MEMBER: 'Member Withdrawal',
      WITHDRAW_RETURN: 'Withdrawal Refund',
      ORDER_BET: 'Order Bet',
      ORDER_PAYOUT: 'Order Payout',
      ORDER_REFUND: 'Order Refund',
      ORDER_FEE: 'Order Fee',
      FUTURE_ORDER: 'Delivery Order',
      FUTURE_FOLLOW: 'Delivery Follow',
      FUTURE_ORDER_CANCEL: 'Delivery Cancel',
      FUTURE_EXECUTION: 'Delivery Settlement',
      TIME_LIMITED_ORDER: 'Timed Order',
      TIME_LIMITED_EXECUTION: 'Timed Settlement',
      TIME_LIMITED_REFUND: 'Timed Refund',
      PERPETUAL_ORDER: 'Perpetual Order',
      PERPETUAL_ORDER_CANCEL: 'Perpetual Cancel',
      PERPETUAL_EXECUTION: 'Perpetual Close',
      PERPETUAL_FEE: 'Perpetual Fee',
      PERPETUAL_PROFIT: 'Perpetual Profit',
      PERPETUAL_LOSS: 'Perpetual Loss',
      PERPETUAL_LIQUIDATION: 'Perpetual Liquidation',
    },
  },
  deposit: {
    title: 'Deposit',
    onlineTitle: 'Merchant Recharge',
    offlineTitle: 'Online Deposit',
    offlineFormTitle: 'Online Deposit',
    loadMerchantsFailed: 'Failed to load merchants',
    loadChannelsFailed: 'Failed to load channels',
    loadAddressesFailed: 'Failed to load addresses',
    submitFailed: 'Submit failed',
    onlineSubmitSuccess: 'Online deposit order created',
    offlineSubmitSuccess: 'Deposit submitted successfully',
    gotIt: 'Got it',
    uploadFailed: 'Failed to upload receipt',
    currency: 'Currency',
    chainName: 'Chain: ({chain})',
    quickAmounts: 'Quick Amounts',
    amountTitle: 'Deposit Amount',
    rechargeRange: 'Allowed amount: {range}',
    estimatedArrival: 'Estimated arrival',
    all: 'All',
    reset: 'Reset',
    rateHint: 'Actual rate is subject to system review (reference only)',
    rebateRate: 'Rebate rate: {rate}%',
    rebateAmount: 'Rebate ({coin}): {amount}',
    submit: 'Submit',
    selectCurrency: 'Select Currency',
    noChannels: 'No deposit channels for this merchant',
    copy: 'Copy',
    copied: 'Copied',
    uploadReceipt: 'Upload transfer receipt',
    receiptAlt: 'Transfer receipt',
    txIdPlaceholder: 'Enter TxId',
  },
  kyc: {
    hubTitle: 'Identity Verification',
    formTitle: 'Verification Details',
    basicTitle: 'Basic Verification',
    identityTitle: 'Identity Verification',
    basicDesc: 'Complete basic email or mobile verification to receive fund notifications and track market updates.',
    identityDesc: 'According to local regulations, identity verification is required to use our full services.',
    goVerify: 'Verify Now',
    reVerify: 'Re-verify',
    viewContent: 'View Verification',
    infoTitle: 'KYC Information',
    imageVerified: 'Verified',
    infoEmpty: 'No verification data',
    info: {
      country: 'Country/Region',
      uploadIdPhoto: 'ID Photo Upload',
    },
    submit: 'Submit',
    promptMessage: 'Please complete KYC verification first',
    verifyLater: 'Verify Later',
    setupNow: 'Set Up Now',
    submittedBanner: 'Application submitted',
    loadFailed: 'Failed to load verification data',
    submitFailed: 'Verification submit failed',
    uploadFailed: 'Failed to upload ID photo',
    selectCountry: 'Select country/region',
    selectGender: 'Select gender',
    selectCertType: 'Select ID type',
    uploadFront: 'Upload front of ID',
    uploadBack: 'Upload back of ID',
    status: {
      verified: 'Verified',
      auditing: 'Under review',
      failed: 'Failed',
      notCertified: 'Not verified',
    },
    certType: {
      idCard: 'ID Card',
      passport: 'Passport',
      driverLicense: 'Driver License',
    },
    gender: {
      male: 'Male',
      female: 'Female',
    },
    fields: {
      country: 'Country/Region',
      image: 'ID Photo Upload',
      birthday: 'Birthday',
      gender: 'Gender',
      realName: 'First Name',
      lastName: 'Last Name',
      certType: 'ID Type',
      identityNumber: 'ID Number',
    },
    placeholder: {
      realName: 'Enter first name',
      lastName: 'Enter last name',
      identityNumber: 'Enter ID number',
    },
    validation: {
      required: 'This field is required',
      imageBoth: 'Please upload both sides of your ID',
    },
  },
  withdraw: {
    title: 'Withdraw',
    currency: 'Currency',
    walletAddress: 'Wallet Address',
    addAddress: 'Add Address',
    addressNotSelected: 'Not selected',
    amountTitle: 'Withdrawal Amount',
    maxAmount: 'Max: {amount}',
    submit: 'Submit',
    loadFailed: 'Failed to load withdrawal data',
    submitFailed: 'Withdrawal failed',
    selectAddress: 'Please select a withdrawal address',
    invalidAmount: 'Please enter a valid amount',
    passwordTitle: 'Transaction Password',
    passwordLabel: 'Transaction Password',
    passwordRequired: 'Please enter transaction password',
    noSetJyPassword: 'Please set a withdrawal password first',
    channel: 'Channel',
    walletAddressPlaceholder: 'Enter wallet address',
    bindSubmit: 'Bind',
    bindFailed: 'Bind failed',
    bindAddressRequired: 'Please enter wallet address',
    addressPromptMessage: 'Please add a withdrawal method first',
    addressPromptLater: 'Add later',
    addressPromptSetup: 'Set up now',
    addressListTitle: 'Withdrawal Addresses',
    boundSection: 'Bound',
    addSection: 'Add withdrawal method',
    bindSuccessBanner: 'Wallet address bound successfully',
    manageAddress: 'Manage address',
    unbindAction: 'Unbind',
    noChannelToAdd: 'No channels available to add',
    manageAddresses: 'Manage addresses',
    bindPageTitle: 'Bind Wallet Address',
    bindSecurityNotice: 'Please verify the wallet address and network. Incorrect addresses may result in lost funds.',
    unbindPageTitle: 'Unbind Withdrawal Method',
    unbindTabEmail: 'Email verification',
    unbindTabPhone: 'Phone verification',
    unbindVerifyCode: 'Verification code',
    unbindVerifyCodePlaceholder: 'Enter verification code',
    unbindSendCode: 'Send code',
    unbindCodeSent: 'Verification code sent',
    unbindSubmit: 'Unbind',
    unbindFailed: 'Unbind failed',
    unbindCodeRequired: 'Please enter verification code',
    unbindCodeSendFailed: 'Failed to send verification code',
    unbindEmailMissing: 'No email bound',
    unbindPhoneMissing: 'No phone number bound',
    setupAddressAction: 'Set up withdrawal method',
    methodsTitle: 'Withdrawal Methods',
    noMethodCategory: 'No withdrawal methods available',
    bindBankPageTitle: 'Bind Bank Card',
    bindEwalletPageTitle: 'Bind Payment Account',
    bindBankSecurityNotice: 'Please verify your bank card details. Incorrect information may cause payout failure.',
    bindEwalletSecurityNotice: 'Please verify your payment account. Incorrect accounts may cause payout failure.',
    bindAccountName: 'Account Name',
    bindAccountNamePlaceholder: 'Enter account name',
    bindAccountNameRequired: 'Please enter account name',
    bindBankName: 'Bank Name',
    bindBankNamePlaceholder: 'Enter bank name',
    bindCardNumber: 'Card Number',
    bindCardNumberPlaceholder: 'Enter card number',
    bindCardNumberRequired: 'Please enter card number',
    bindEwalletAccount: 'Payment Account',
    bindEwalletAccountPlaceholder: 'Enter payment account',
    selectCurrency: 'Select Currency',
    bankCard: 'Bank Card',
    availableAmount: 'Available {amount}',
    amountLabel: '{currency} Withdrawal Amount',
    estimatedArrival: 'Estimated Arrival',
    exchangeRateNote: 'Actual exchange rate is subject to system review (reference only).',
    handlingFee: 'Handling Fee',
    feeNote: 'The handling fee will be deducted from your withdrawal amount. The actual arrival amount shall prevail.',
    noWithdrawableChannel: 'No withdrawal channel available. Please bind an address and ensure the channel is enabled.',
    copyAddress: 'Copy address',
    copied: 'Copied',
    copyFailed: 'Copy failed',
    exceedMaxAmount: 'Exceeds maximum withdrawal amount {amount}',
  },
  news: {
    title: 'International News',
    more: 'More ›',
    empty: 'No news available',
    loadFailed: 'Failed to load',
    prevPage: 'Previous',
    nextPage: 'Next',
  },
  messages: {
    title: 'Messages',
    readAll: 'Mark all read',
    tabInbox: 'Inbox',
    tabAnnouncement: 'Announcements',
    empty: 'No data',
    loadFailed: 'Failed to load',
    prevPage: 'Previous',
    nextPage: 'Next',
  },
  helpCenter: {
    title: 'Help Center',
    searchPlaceholder: 'Enter your question',
    faqTitle: 'FAQ',
    empty: 'No help articles yet',
    loadFailed: 'Failed to load',
  },
  aboutUs: {
    title: 'About Us',
  },
  beginnerGuide: {
    title: 'Beginner Guide',
  },
  support: {
    title: 'Customer Service',
    defaultName: 'Support',
    contactNow: 'Contact Now',
    copied: 'Copied to clipboard',
    empty: 'No customer service available',
    offlineHint: 'Customer service is currently offline',
    loadFailed: 'Failed to load',
  },
  auth: {
    navRegister: 'Register',
    navLogin: 'Log in',
    googleSignIn: 'Sign in with Google',
    googleSignUp: 'Sign up with Google',
    googleCredentialMissing: 'Google credential not received',
    googleLoginFailed: 'Google sign-in failed. Please try again later',
  },
  login: {
    title: 'Welcome back',
    tabEmail: 'Email',
    tabMobile: 'Phone',
    usernamePlaceholder: 'Enter username or email',
    mobilePlaceholder: 'Enter mobile number',
    passwordPlaceholder: 'Enter your password',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password?',
    submit: 'Log in',
    submitting: 'Signing in…',
    touristSubmit: 'Guest trial (no registration)',
    touristSubmitting: 'Creating guest account…',
    divider: 'Or sign in with',
    loginFailed: 'Sign-in failed. Please try again later',
    touristFailed: 'Failed to create guest account. Please try again later',
  },
  register: {
    title: 'Create Account',
    subtitle: 'You will be signed in automatically after registration',
    tabEmail: 'Email',
    tabMobile: 'Phone',
    username: 'Username',
    password: 'Password (6–12 characters, no spaces)',
    nickname: 'Nickname (optional)',
    email: 'Email',
    mobile: 'Mobile number',
    inviterCode: 'Invitation code',
    verifyCode: 'Verification code',
    sendCode: 'Send code',
    sendingCode: 'Sending…',
    submit: 'Register',
    submitting: 'Registering…',
    divider: 'Or register with',
    agreePrefix: 'By checking this box, you agree to the',
    userAgreement: 'User Agreement',
    privacyPolicy: 'Privacy Policy',
    agreeConnector: '&',
    agreeRequired: 'Please accept the User Agreement and Privacy Policy',
    emailRequired: 'Please enter your email first',
    mobileRequired: 'Please enter your mobile number first',
    codeSent: 'Verification code sent',
    sendCodeFailed: 'Failed to send verification code',
    registerFailed: 'Registration failed. Please try again later',
  },
  invite: {
    title: 'Invite Friends',
    hint: 'Share your invitation code or link. Friends will use your code when they register.',
    codeLabel: 'My invitation code',
    linkLabel: 'Invitation link',
    copyCode: 'Copy code',
    copyLink: 'Copy link',
    copied: 'Copied to clipboard',
    copyFailed: 'Copy failed',
    loadFailed: 'Failed to load',
  },
  backfillInviter: {
    title: 'Enter invitation code',
    hint: 'If you registered without an invitation code, you can add one here. This only affects future commission attribution, not trading or withdrawal rights.',
    codeLabel: 'Invitation code',
    codePlaceholder: 'Enter your inviter\'s code',
    codeRequired: 'Please enter an invitation code',
    submit: 'Submit',
    submitFailed: 'Submission failed. Please try again later',
    loadFailed: 'Failed to load',
    notAvailable: 'Invitation code backfill is not available (already bound, expired, or agent account).',
    deadline: 'Backfill deadline: {deadline}',
    success: 'Successfully bound to inviter: {inviter}',
  },
  agreement: {
    title: 'User Agreement',
    loadFailed: 'Failed to load',
    empty: 'No content available',
  },
  privacyPolicy: {
    title: 'Privacy Policy',
    loadFailed: 'Failed to load',
    empty: 'No content available',
  },
  chat: {
    mutedUntil: 'You are muted. Time remaining until unmute: {remaining}. You can still view history.',
    mutedPermanent: 'You are permanently muted and cannot send messages. You can still view history.',
    muteRemainingDays: '{0} day(s)',
    muteRemainingHours: '{0} hour(s)',
    muteRemainingMinutes: '{0} minute(s)',
    mutePermanent: 'permanent',
  },
  travel: travelEnUS,
};

const zh_CN = {
  authErrors: AUTH_ERROR_MESSAGES.zh_CN,
  emailVerification: { accepted: '请求已受理；符合条件时将尝试寄送，尚不代表已寄出或送达。未收到可稍后重试。', receiptInvalid: '无法确认请求是否受理，请稍后再试。' },
  common: {
    hint: '提示',
    cancel: '取消',
    confirm: '确认',
    close: '关闭',
    loading: '加载中…',
    noData: '无数据',
    dash: '—',
    back: '返回',
    search: '搜索',
  },
  trade: {
    positions: '持仓明细',
    buyUp: '买涨',
    buyDown: '买跌',
    pendingDraw: '待开奖',
    unsettled: '未结算',
    settlementCountdown: '结算倒计时',
    settlementTime: '交割时间',
    orderAmount: '下单金额',
    fillPrice: '成交价',
    currentPrice: '现价',
    profitLoss: '盈亏金额',
    fee: '手续费',
    cancelOrder: '撤单',
    cancelConfirm: '确认将当前委托订单撤销？',
    cancelSuccess: '订单撤销成功',
    cancelFailed: '撤单失败',
    placeOrderFailed: '下单失败',
    loadProductsFailed: '加载商品失败',
    chartAria: 'K 线',
    stateBooked: '已下单',
    stateSettled: '已结算',
    stateCancelled: '已取消',
  },
  orders: {
    title: '订单',
    tabTimed: '限时',
    tabFutures: '交割',
    tabPerpetual: '永续',
    positions: '持仓明细',
    history: '历史明细',
    pending: '当前委托',
    open: '持仓中',
    entrustHistory: '历史委托',
    positionHistory: '历史持仓',
    loadFailed: '加载订单失败',
    closeFailed: '平仓失败',
  },
  follow: {
    oneClick: '一鍵跟單',
    title: '一鍵跟單',
    deliveryTitle: '交割跟單',
    signalsLabel: '動態口令',
    signalsPlaceholder: '請輸入動態口令',
    signalsInvalid: '動態口令不正確',
    submit: '送出',
    name: '名稱',
    period: '週期',
    followAmount: '跟單金額',
    minFollowAmount: '最低跟單金額',
    maxFollowAmount: '最高跟單金額',
    confirmTitle: '跟單',
    confirmMessage: '確認要跟單 {amount}(USDT)嗎？',
    success: '跟單成功！',
    loadFailed: '載入跟單失敗',
    placeFailed: '跟單失敗',
    noMore: '沒有更多了',
    amountOutOfRange: '金額須在 {min} ~ {max} 之間',
  },
  settings: {
    title: '通用设置',
    language: '语言',
    languageTitle: '语言',
    fiatCurrency: '法币类型',
    version: '版本',
    logout: '登出',
    login: '登录',
    loadLanguagesFailed: '语系列表加载失败',
  },
  security: {
    title: '安全中心',
    email: '信箱',
    phone: '手机',
    withdrawPassword: '提现密码',
    loginPassword: '登录密码',
    notBound: '未绑定',
    goSet: '去设置',
    modify: '修改',
    set: '设定',
    withdrawPasswordSetTitle: '提现密码设定',
    withdrawPasswordModifyTitle: '提现密码设定',
    loginPasswordModifyTitle: '登录密码设定',
    tabPhone: '手机',
    tabEmail: '邮箱',
    phoneNumber: '手机号码',
    verifyCode: '验证码',
    verifyCodePlaceholder: '请输入验证码',
    sendCode: '发送验证码',
    codeSent: '验证码已发送',
    oldPassword: '旧密码',
    oldPasswordPlaceholder: '请输入旧密码',
    newPassword: '新密码',
    newPasswordPlaceholder: '请输入新密码',
    confirmPassword: '再次输入密码',
    confirmPasswordPlaceholder: '请再次输入密码',
    passwordFormat: '密码须为 6～12 字且不含空白',
    passwordMismatch: '两次输入的密码不一致',
    saveFailed: '密码设定失败',
    codeSendFailed: '验证码发送失败',
    emailMissing: '尚未绑定信箱',
    phoneMissing: '尚未绑定手机',
  },
  funds: {
    title: '资金',
    detailsTitle: '资金明细',
    details: '明细',
    deposit: '入款',
    withdraw: '取款',
    tabAll: '全部',
    tabDeposit: '入款纪录',
    tabWithdraw: '取款纪录',
    tabTimed: '限时',
    tabFutures: '交割',
    tabPerpetual: '永续',
    positionsTitle: '持仓',
    todayProfit: '今日收益 ({coin})',
    positionMargin: '仓位保证金',
    futuresHolding: '持仓中',
    marginBalance: '保证金余额 ({coin})',
    unrealizedPnl: '未实现盈亏 ({coin})',
    historyPositions: '历史持仓',
    openPositions: '持有仓位',
    positionAmountLabel: '金额 {amount}',
    positionLoginHint: '登录后可查看持仓资料',
    positionLoadFailed: '加载持仓资料失败',
    directionUp: '买涨',
    directionDown: '买跌',
    directionLong: '做多',
    directionShort: '做空',
    perpetualStatusOpen: '持仓中',
    perpetualStatusPending: '委托中',
    perpetualStatusClosed: '已平仓',
    perpetualStatusLiquidated: '已强平',
    totalAssets: '账户总资产 ({coin})',
    available: '可用',
    locked: '锁定',
    staked: '锁仓',
    withdrawalStats: '提款统计',
    showBalance: '显示余额',
    hideBalance: '隐藏余额',
    feeLabel: '手续费 : {amount}',
    balanceLabel: '余额 : {amount}',
    depositAmountLabel: '充币{currency} : {amount}',
    withdrawAmountLabel: '金额 {currency} : {amount}',
    receivedAmountLabel: '预计到账数量 : {amount}',
    loadFailed: '加载资金资料失败',
    loadMore: '加载更多',
    noMore: '没有更多了',
    paymentStatus: {
      NONE: '无状态',
      PENDING: '待处理',
      PROCESSING: '处理中',
      WAITING_CALLBACK: '待回调',
      FAIL: '失败',
      REJECT: '拒绝',
      SUCCESS: '已完成',
      TIMEOUT: '超时',
      EXCEPTION: '异常',
    },
    depositType: {
      RECHARGE_SYSTEM: '注册礼金',
      RECHARGE_ONLINE: '在线充值',
      RECHARGE_OFFLINE: '线下充值',
    },
    transactionType: {
      RECHARGE_SYSTEM: '系统上分',
      RECHARGE_ONLINE: '在线充值',
      RECHARGE_OFFLINE: '离线充值',
      WITHDRAWAL_SYSTEM: '系统下分',
      WITHDRAWAL_ONLINE: '线上提款',
      WITHDRAWAL_OFFLINE: '线下提现',
      WITHDRAWAL_MEMBER: '用户提现',
      WITHDRAW_RETURN: '取消用户提现退款',
      ORDER_BET: '下单扣款',
      ORDER_PAYOUT: '派彩入账',
      ORDER_REFUND: '撤单退款',
      ORDER_FEE: '下单手续费',
      FUTURE_ORDER: '交割合约委托',
      FUTURE_FOLLOW: '交割跟单委托',
      FUTURE_ORDER_CANCEL: '交割合约撤单',
      FUTURE_EXECUTION: '交割合约结算',
      TIME_LIMITED_ORDER: '限时委托',
      TIME_LIMITED_EXECUTION: '限时成交',
      TIME_LIMITED_REFUND: '限时失败退款',
      PERPETUAL_ORDER: '永续合约委托',
      PERPETUAL_ORDER_CANCEL: '永续合约撤单',
      PERPETUAL_EXECUTION: '永续合约平仓结算',
      PERPETUAL_FEE: '永续合约手续费',
      PERPETUAL_PROFIT: '永续合约盈利',
      PERPETUAL_LOSS: '永续合约亏损',
      PERPETUAL_LIQUIDATION: '永续合约强平',
    },
  },
  deposit: {
    title: '入款',
    onlineTitle: '商户充值',
    offlineTitle: '在线充值',
    offlineFormTitle: '在线充值',
    loadMerchantsFailed: '加载商户失败',
    loadChannelsFailed: '加载充值通道失败',
    loadAddressesFailed: '加载充值地址失败',
    submitFailed: '提交失败',
    onlineSubmitSuccess: '线上充值订单已建立',
    offlineSubmitSuccess: '入款提交成功',
    gotIt: '知道了',
    uploadFailed: '凭证上传失败',
    currency: '币种',
    chainName: '链名称: ({chain})',
    quickAmounts: '充值快捷金额',
    amountTitle: '入款金额',
    rechargeRange: '可充值金额：{range}',
    estimatedArrival: '预估到账金额',
    all: '全部',
    reset: '重置',
    rateHint: '实际汇率以系统审核为主(此为参考价)',
    rebateRate: '奖励金返现比例：{rate}%',
    rebateAmount: '奖励金 ({coin})：{amount}',
    submit: '提交',
    selectCurrency: '选择币种',
    noChannels: '此商户暂无可充值币种',
    copy: '复制',
    copied: '已复制',
    uploadReceipt: '上传转账凭证',
    receiptAlt: '转账凭证',
    txIdPlaceholder: '请输入TxId',
  },
  kyc: {
    hubTitle: '身份认证',
    formTitle: '填写认证信息',
    basicTitle: '基本认证',
    identityTitle: '身份认证',
    basicDesc: '完成基本的电子邮件或手机身份验证，因此将通过电子邮件或手机自动通知资金交易，并立即跟踪市场动态。',
    identityDesc: '根据当地法律法规，您需要完成身份认证才能使用我们的完整服务。',
    goVerify: '去认证',
    reVerify: '重新认证',
    viewContent: '查看认证内容',
    infoTitle: 'KYC认证资讯',
    imageVerified: '已认证',
    infoEmpty: '暂无认证资料',
    info: {
      country: '国家/地区',
      uploadIdPhoto: '上传证件照',
    },
    submit: '提交',
    promptMessage: '请您先设定KYC认证',
    verifyLater: '稍后认证',
    setupNow: '现在设置',
    submittedBanner: '申请已提交',
    loadFailed: '载入认证资料失败',
    submitFailed: '认证提交失败',
    uploadFailed: '证件照片上传失败',
    selectCountry: '请选择国家/地区',
    selectGender: '请选择性别',
    selectCertType: '请选择证件类型',
    uploadFront: '上传证件照正面',
    uploadBack: '上传证件照背面',
    status: {
      verified: '已认证',
      auditing: '审核中',
      failed: '认证失败',
      notCertified: '未认证',
    },
    certType: {
      idCard: '身份证',
      passport: '护照',
      driverLicense: '驾照',
    },
    gender: {
      male: '男',
      female: '女',
    },
    fields: {
      country: '国家/地区',
      image: '证件照片上传',
      birthday: '生日',
      gender: '性别',
      realName: '名字',
      lastName: '姓氏',
      certType: '证件类型',
      identityNumber: '证件号码',
    },
    placeholder: {
      realName: '请输入名字',
      lastName: '请输入姓氏',
      identityNumber: '请输入证件号码',
    },
    validation: {
      required: '此栏位为必填',
      imageBoth: '请上传证件照正反面',
    },
  },
  withdraw: {
    title: '取款',
    currency: '币种',
    walletAddress: '钱包地址',
    addAddress: '钱包地址新增',
    addressNotSelected: '尚未选择',
    amountTitle: '取款金额',
    maxAmount: '最大：{amount}',
    submit: '提交',
    loadFailed: '载入取款资料失败',
    submitFailed: '提款失败',
    selectAddress: '请选择提款地址',
    invalidAmount: '请输入有效提款金额',
    passwordTitle: '交易密码',
    passwordLabel: '交易密码',
    passwordRequired: '请输入交易密码',
    noSetJyPassword: '请先设定提现密码',
    channel: '通道',
    walletAddressPlaceholder: '请输入钱包地址',
    bindSubmit: '绑定',
    bindFailed: '绑定失败',
    bindAddressRequired: '请输入钱包地址',
    addressPromptMessage: '请先新增出款方式',
    addressPromptLater: '稍后新增',
    addressPromptSetup: '现在设置',
    addressListTitle: '出金地址',
    boundSection: '已绑定',
    addSection: '新增出款方式',
    bindSuccessBanner: '绑定钱包地址成功',
    manageAddress: '管理地址',
    unbindAction: '解绑出款方式',
    noChannelToAdd: '暂无可新增的出款通道',
    manageAddresses: '管理出款地址',
    bindPageTitle: '绑定钱包地址',
    bindSecurityNotice: '请确认钱包地址与链路正确，错误地址可能导致资产无法找回。',
    unbindPageTitle: '解绑出款方式',
    unbindTabEmail: '信箱验证',
    unbindTabPhone: '手机验证',
    unbindVerifyCode: '验证码',
    unbindVerifyCodePlaceholder: '请输入验证码',
    unbindSendCode: '发送验证码',
    unbindCodeSent: '验证码已发送',
    unbindSubmit: '解绑',
    unbindFailed: '解绑失败',
    unbindCodeRequired: '请输入验证码',
    unbindCodeSendFailed: '验证码发送失败',
    unbindEmailMissing: '尚未绑定信箱',
    unbindPhoneMissing: '尚未绑定手机号',
    setupAddressAction: '设置出款方式',
    methodsTitle: '取款方式',
    noMethodCategory: '暂无可选取款方式',
    bindBankPageTitle: '绑定银行卡',
    bindEwalletPageTitle: '绑定支付账号',
    bindBankSecurityNotice: '请确认银行卡信息正确，错误信息可能导致出款失败。',
    bindEwalletSecurityNotice: '请确认支付账号正确，错误账号可能导致出款失败。',
    bindAccountName: '户名',
    bindAccountNamePlaceholder: '请输入户名',
    bindAccountNameRequired: '请输入户名',
    bindBankName: '开户行',
    bindBankNamePlaceholder: '请输入开户行名称',
    bindCardNumber: '银行卡号',
    bindCardNumberPlaceholder: '请输入银行卡号',
    bindCardNumberRequired: '请输入银行卡号',
    bindEwalletAccount: '支付账号',
    bindEwalletAccountPlaceholder: '请输入支付账号',
    selectCurrency: '选择币种',
    bankCard: '银行卡',
    availableAmount: '可取款金额 {amount}',
    amountLabel: '{currency} 取款金额',
    estimatedArrival: '预估到帐金额',
    exchangeRateNote: '实际汇率以系统审核为主（此为参考价）',
    handlingFee: '手续费',
    feeNote: '您的本次取款，手续费将在您本次的取款金额中扣除，实际金额以实际到帐金额为准。',
    noWithdrawableChannel: '暂无可用的提款通道，请确认已绑定地址且后台已开启提现通道',
    copyAddress: '复制地址',
    copied: '已复制',
    copyFailed: '复制失败',
    exceedMaxAmount: '超过可取款上限 {amount}',
  },
  news: {
    title: '国际新闻',
    more: '更多 ›',
    empty: '暂无新闻',
    loadFailed: '载入失败',
    prevPage: '上一页',
    nextPage: '下一页',
  },
  messages: {
    title: '消息公告',
    readAll: '全部已读',
    tabInbox: '站内信',
    tabAnnouncement: '公告',
    empty: '无数据',
    loadFailed: '载入失败',
    prevPage: '上一页',
    nextPage: '下一页',
  },
  helpCenter: {
    title: '帮助中心',
    searchPlaceholder: '请输入您的问题',
    faqTitle: '常见问题',
    empty: '暂无帮助内容',
    loadFailed: '载入失败',
  },
  aboutUs: {
    title: '关于我们',
  },
  beginnerGuide: {
    title: '新手指南',
  },
  support: {
    title: '客服中心',
    defaultName: '客服',
    contactNow: '立即溝通',
    copied: '已複製到剪貼簿',
    empty: '暫無可用客服',
    offlineHint: '目前非客服在線時段',
    loadFailed: '載入失敗',
  },
  auth: {
    navRegister: '注册',
    navLogin: '登录',
    googleSignIn: '使用 Google 登录',
    googleSignUp: '使用 Google 注册',
    googleCredentialMissing: '未取得 Google 凭证',
    googleLoginFailed: 'Google 登录失败，请稍后再试',
  },
  login: {
    title: '欢迎回来',
    tabEmail: '邮箱登录',
    tabMobile: '手机登录',
    usernamePlaceholder: '请输入账号或 Email',
    mobilePlaceholder: '请输入手机号码',
    passwordPlaceholder: '请输入您的密码',
    rememberMe: '记住我',
    forgotPassword: '忘记密码？',
    submit: '登录',
    submitting: '登录中…',
    touristSubmit: '游客试玩（免注册）',
    touristSubmitting: '建立试玩账号中…',
    divider: '或使用以下方式登录',
    loginFailed: '登录失败，请稍后再试',
    touristFailed: '试玩账号建立失败，请稍后再试',
  },
  register: {
    title: '建立账号',
    subtitle: '注册成功后将自动登录',
    tabEmail: '邮箱注册',
    tabMobile: '手机注册',
    username: '账号',
    password: '密码（6～12 字，不含空白）',
    nickname: '昵称（选填）',
    email: 'Email',
    mobile: '手机号码',
    inviterCode: '邀请码',
    verifyCode: '验证码',
    sendCode: '发送验证码',
    sendingCode: '发送中…',
    submit: '注册',
    submitting: '注册中…',
    divider: '或使用以下方式注册',
    agreePrefix: '勾选即代表同意',
    userAgreement: '用户协议',
    privacyPolicy: '隐私条款',
    agreeConnector: '&',
    agreeRequired: '请先勾选用户协议与隐私条款',
    emailRequired: '请先填写 Email',
    mobileRequired: '请先填写手机号码',
    codeSent: '验证码已发送',
    sendCodeFailed: '验证码发送失败',
    registerFailed: '注册失败，请稍后再试',
  },
  invite: {
    title: '好友邀请',
    hint: '分享您的邀请码或邀请链接，好友注册时将自动带入您的推广码。',
    codeLabel: '我的邀请码',
    linkLabel: '邀请链接',
    copyCode: '复制邀请码',
    copyLink: '复制链接',
    copied: '已复制到剪贴板',
    copyFailed: '复制失败',
    loadFailed: '载入失败',
  },
  backfillInviter: {
    title: '输入邀请码',
    hint: '您注册时未填写邀请码，可在此补填。成功后仅影响后续佣金归属，不影响下单、提现等权益。',
    codeLabel: '邀请码',
    codePlaceholder: '请输入邀请人的邀请码',
    codeRequired: '请输入邀请码',
    submit: '确认提交',
    submitFailed: '提交失败，请稍后再试',
    loadFailed: '载入失败',
    notAvailable: '目前无法补填邀请码（可能已绑定上级、已过期限，或您为代理账号）。',
    deadline: '补填截止时间：{deadline}',
    success: '已成功绑定邀请人：{inviter}',
  },
  agreement: {
    title: '用户协议',
    loadFailed: '载入失败',
    empty: '暂无内容',
  },
  privacyPolicy: {
    title: '隐私条款',
    loadFailed: '载入失败',
    empty: '暂无内容',
  },
  chat: {
    mutedUntil: '你已被禁言，距离解禁还有：{remaining}；仍可查看历史对话',
    mutedPermanent: '你已被永久禁言，无法发送消息；仍可查看历史对话',
    muteRemainingDays: '{0} 天',
    muteRemainingHours: '{0} 小时',
    muteRemainingMinutes: '{0} 分钟',
    mutePermanent: '永久',
  },
  travel: travelZhCN,
};

const es_ES = {
  common: {
    hint: 'Aviso',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    close: 'Cerrar',
    loading: 'Cargando…',
    noData: 'Sin datos',
    dash: '—',
    back: 'Volver',
    search: 'Buscar',
  },
  trade: {
    positions: 'Posiciones',
    buyUp: 'Comprar alza',
    buyDown: 'Comprar baja',
    pendingDraw: 'Pendiente',
    unsettled: 'Sin liquidar',
    settlementCountdown: 'Cuenta regresiva',
    settlementTime: 'Liquidación',
    orderAmount: 'Monto',
    fillPrice: 'Precio ejecución',
    currentPrice: 'Precio actual',
    profitLoss: 'G/P',
    fee: 'Comisión',
    cancelOrder: 'Cancelar orden',
    cancelConfirm: '¿Cancelar esta orden abierta?',
    cancelSuccess: 'Orden cancelada',
    cancelFailed: 'Error al cancelar',
    placeOrderFailed: 'Error al ordenar',
    loadProductsFailed: 'Error al cargar productos',
    chartAria: 'Gráfico',
    stateBooked: 'Reservada',
    stateSettled: 'Liquidada',
    stateCancelled: 'Cancelada',
  },
  follow: {
    oneClick: 'One-Click Copy',
    title: 'One-Click Copy',
    deliveryTitle: 'Delivery Copy',
    signalsLabel: 'Passcode',
    signalsPlaceholder: 'Enter passcode',
    signalsInvalid: 'Invalid passcode',
    submit: 'Submit',
    name: 'Name',
    period: 'Period',
    followAmount: 'Copy Amount',
    minFollowAmount: 'Min Copy Amount',
    maxFollowAmount: 'Max Copy Amount',
    confirmTitle: 'Copy Trade',
    confirmMessage: 'Confirm copy trade {amount}(USDT)?',
    success: 'Copy trade successful!',
    loadFailed: 'Failed to load copy trades',
    placeFailed: 'Copy trade failed',
    noMore: 'No more',
    amountOutOfRange: 'Amount must be between {min} and {max}',
  },
  settings: {
    title: 'Ajustes generales',
    language: 'Idioma',
    languageTitle: 'Idioma',
    fiatCurrency: 'Moneda fiat',
    version: 'Versión',
    logout: 'Cerrar sesión',
    login: 'Iniciar sesión',
    loadLanguagesFailed: 'Error al cargar idiomas',
  },
};

const fr_FR = {
  common: {
    hint: 'Avis',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    close: 'Fermer',
    loading: 'Chargement…',
    noData: 'Aucune donnée',
    dash: '—',
    back: 'Retour',
    search: 'Rechercher',
  },
  trade: {
    positions: 'Positions',
    buyUp: 'Acheter hausse',
    buyDown: 'Acheter baisse',
    pendingDraw: 'En attente',
    unsettled: 'Non réglé',
    settlementCountdown: 'Compte à rebours',
    settlementTime: 'Règlement',
    orderAmount: 'Montant',
    fillPrice: 'Prix exécution',
    currentPrice: 'Prix actuel',
    profitLoss: 'P/L',
    fee: 'Frais',
    cancelOrder: 'Annuler',
    cancelConfirm: 'Annuler cet ordre en cours ?',
    cancelSuccess: 'Ordre annulé',
    cancelFailed: 'Échec annulation',
    placeOrderFailed: 'Échec commande',
    loadProductsFailed: 'Échec chargement',
    chartAria: 'Graphique',
    stateBooked: 'Réservé',
    stateSettled: 'Réglé',
    stateCancelled: 'Annulé',
  },
  follow: {
    oneClick: 'One-Click Copy',
    title: 'One-Click Copy',
    deliveryTitle: 'Delivery Copy',
    signalsLabel: 'Passcode',
    signalsPlaceholder: 'Enter passcode',
    signalsInvalid: 'Invalid passcode',
    submit: 'Submit',
    name: 'Name',
    period: 'Period',
    followAmount: 'Copy Amount',
    minFollowAmount: 'Min Copy Amount',
    maxFollowAmount: 'Max Copy Amount',
    confirmTitle: 'Copy Trade',
    confirmMessage: 'Confirm copy trade {amount}(USDT)?',
    success: 'Copy trade successful!',
    loadFailed: 'Failed to load copy trades',
    placeFailed: 'Copy trade failed',
    noMore: 'No more',
    amountOutOfRange: 'Amount must be between {min} and {max}',
  },
  settings: {
    title: 'Paramètres généraux',
    language: 'Langue',
    languageTitle: 'Langue',
    fiatCurrency: 'Devise fiat',
    version: 'Version',
    logout: 'Déconnexion',
    login: 'Connexion',
    loadLanguagesFailed: 'Échec du chargement des langues',
  },
};

const ru_RU = {
  common: {
    hint: 'Подсказка',
    cancel: 'Отмена',
    confirm: 'Подтвердить',
    close: 'Закрыть',
    loading: 'Загрузка…',
    noData: 'Нет данных',
    dash: '—',
    back: 'Назад',
    search: 'Поиск',
  },
  trade: {
    positions: 'Позиции',
    buyUp: 'Покупка рост',
    buyDown: 'Покупка падение',
    pendingDraw: 'Ожидание',
    unsettled: 'Не рассчитано',
    settlementCountdown: 'Обратный отсчёт',
    settlementTime: 'Расчёт',
    orderAmount: 'Сумма',
    fillPrice: 'Цена исполнения',
    currentPrice: 'Текущая цена',
    profitLoss: 'П/У',
    fee: 'Комиссия',
    cancelOrder: 'Отменить',
    cancelConfirm: 'Отменить текущий ордер?',
    cancelSuccess: 'Ордер отменён',
    cancelFailed: 'Ошибка отмены',
    placeOrderFailed: 'Ошибка ордера',
    loadProductsFailed: 'Ошибка загрузки',
    chartAria: 'График',
    stateBooked: 'Размещён',
    stateSettled: 'Рассчитан',
    stateCancelled: 'Отменён',
  },
  follow: {
    oneClick: 'One-Click Copy',
    title: 'One-Click Copy',
    deliveryTitle: 'Delivery Copy',
    signalsLabel: 'Passcode',
    signalsPlaceholder: 'Enter passcode',
    signalsInvalid: 'Invalid passcode',
    submit: 'Submit',
    name: 'Name',
    period: 'Period',
    followAmount: 'Copy Amount',
    minFollowAmount: 'Min Copy Amount',
    maxFollowAmount: 'Max Copy Amount',
    confirmTitle: 'Copy Trade',
    confirmMessage: 'Confirm copy trade {amount}(USDT)?',
    success: 'Copy trade successful!',
    loadFailed: 'Failed to load copy trades',
    placeFailed: 'Copy trade failed',
    noMore: 'No more',
    amountOutOfRange: 'Amount must be between {min} and {max}',
  },
  settings: {
    title: 'Общие настройки',
    language: 'Язык',
    languageTitle: 'Язык',
    fiatCurrency: 'Фиатная валюта',
    version: 'Версия',
    logout: 'Выйти',
    login: 'Войти',
    loadLanguagesFailed: 'Не удалось загрузить языки',
  },
};

const sw_TZ = {
  common: {
    hint: 'Taarifa',
    cancel: 'Ghairi',
    confirm: 'Thibitisha',
    close: 'Funga',
    loading: 'Inapakia…',
    noData: 'Hakuna data',
    dash: '—',
    back: 'Rudi',
    search: 'Tafuta',
  },
  trade: {
    positions: 'Nafasi',
    buyUp: 'Nunua juu',
    buyDown: 'Nunua chini',
    pendingDraw: 'Inasubiri',
    unsettled: 'Hindi pa na-settle',
    settlementCountdown: 'Countdown',
    settlementTime: 'Muda wa malipo',
    orderAmount: 'Kiasi',
    fillPrice: 'Bei ya kutekeleza',
    currentPrice: 'Bei ya sasa',
    profitLoss: 'Faida/Hasara',
    fee: 'Ada',
    cancelOrder: 'Ghairi agizo',
    cancelConfirm: 'Ghairi agizo hili?',
    cancelSuccess: 'Agizo limeghairiwa',
    cancelFailed: 'Imeshindwa kughairi',
    placeOrderFailed: 'Agizo limeshindwa',
    loadProductsFailed: 'Imeshindwa kupakia',
    chartAria: 'Chati',
    stateBooked: 'Imewekwa',
    stateSettled: 'Imelipwa',
    stateCancelled: 'Imeghairiwa',
  },
  follow: {
    oneClick: 'One-Click Copy',
    title: 'One-Click Copy',
    deliveryTitle: 'Delivery Copy',
    signalsLabel: 'Passcode',
    signalsPlaceholder: 'Enter passcode',
    signalsInvalid: 'Invalid passcode',
    submit: 'Submit',
    name: 'Name',
    period: 'Period',
    followAmount: 'Copy Amount',
    minFollowAmount: 'Min Copy Amount',
    maxFollowAmount: 'Max Copy Amount',
    confirmTitle: 'Copy Trade',
    confirmMessage: 'Confirm copy trade {amount}(USDT)?',
    success: 'Copy trade successful!',
    loadFailed: 'Failed to load copy trades',
    placeFailed: 'Copy trade failed',
    noMore: 'No more',
    amountOutOfRange: 'Amount must be between {min} and {max}',
  },
  settings: {
    title: 'Mipangilio ya jumla',
    language: 'Lugha',
    languageTitle: 'Lugha',
    fiatCurrency: 'Sarafu ya fiat',
    version: 'Toleo',
    logout: 'Ondoka',
    login: 'Ingia',
    loadLanguagesFailed: 'Imeshindwa kupakia lugha',
  },
};

const rw_RW = {
  common: {
    hint: 'Iburira',
    cancel: 'Hagarika',
    confirm: 'Emeza',
    close: 'Funga',
    loading: 'Birimo gupakira…',
    noData: 'Nta makuru',
    dash: '—',
    back: 'Subira inyuma',
    search: 'Shakisha',
  },
  trade: {
    positions: 'Imyanya',
    buyUp: 'Gura hejuru',
    buyDown: 'Gura hasi',
    pendingDraw: 'Bitegereje',
    unsettled: 'Ntacyashyizwaho',
    settlementCountdown: 'Guharanira',
    settlementTime: 'Igihe cyo kurangiza',
    orderAmount: 'Amafaranga',
    fillPrice: 'Igiciro cyo gucuruza',
    currentPrice: 'Igiciro ubu',
    profitLoss: 'Inyungu/Igihombo',
    fee: 'Amafaranga y\'ikoranabuhanga',
    cancelOrder: 'Hagarika itegeko',
    cancelConfirm: 'Hagarika iri tegeko?',
    cancelSuccess: 'Itegeko ryahagaritswe',
    cancelFailed: 'Byanze guhagarika',
    placeOrderFailed: 'Byanze gutumiza',
    loadProductsFailed: 'Byanze gupakira',
    chartAria: 'Igishushanyo',
    stateBooked: 'Byanditswe',
    stateSettled: 'Byarangiye',
    stateCancelled: 'Byahagaritswe',
  },
  follow: {
    oneClick: 'One-Click Copy',
    title: 'One-Click Copy',
    deliveryTitle: 'Delivery Copy',
    signalsLabel: 'Passcode',
    signalsPlaceholder: 'Enter passcode',
    signalsInvalid: 'Invalid passcode',
    submit: 'Submit',
    name: 'Name',
    period: 'Period',
    followAmount: 'Copy Amount',
    minFollowAmount: 'Min Copy Amount',
    maxFollowAmount: 'Max Copy Amount',
    confirmTitle: 'Copy Trade',
    confirmMessage: 'Confirm copy trade {amount}(USDT)?',
    success: 'Copy trade successful!',
    loadFailed: 'Failed to load copy trades',
    placeFailed: 'Copy trade failed',
    noMore: 'No more',
    amountOutOfRange: 'Amount must be between {min} and {max}',
  },
  settings: {
    title: 'Igenamiterere rusange',
    language: 'Ururimi',
    languageTitle: 'Ururimi',
    fiatCurrency: 'Ubwoko bw\'amafaranga',
    version: 'Verisiyo',
    logout: 'Gusohoka',
    login: 'Injira',
    loadLanguagesFailed: 'Byanze gupakira indimi',
  },
};

export const DEFAULT_LOCALE = 'zh_TW';
export const FALLBACK_LOCALE = 'en_US';

export const MESSAGES = {
  zh_TW,
  zh_CN,
  en_US,
  es_ES,
  fr_FR,
  ru_RU,
  sw_TZ,
  rw_RW,
};
